import { createContext, useContext } from 'react';
import { SELECTION_MODE } from './constants';
export const ToggleGroupContext = createContext({
    value: undefined,
    onChange: undefined,
    selectionMode: SELECTION_MODE.Single,
});
export const useToggleGroupContext = () => useContext(ToggleGroupContext);
